import React, {useState, useRef, useEffect} from "react";
import { Link } from "react-router-dom";
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import {AuthContext} from './../App'
import { ArrowDown } from "./images/Arrows";

const useAuth = () => {
    return React.useContext(AuthContext);
}

function useOutsideAlerter(ref, callback) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export const TopRightDropdown = (props) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { username} = props;
    const { onLogout } = useAuth();
    const wrapperRef = useRef(null);
    const closeDropdown = () => {
      setDropdownOpen(false);
    }

    useOutsideAlerter(wrapperRef, closeDropdown);
    const initial = username ? username.charAt(0).toUpperCase() : "U";

    return (
        <div className="relative flex items-center" ref={wrapperRef}>
            <button
                className="flex items-center gap-3 rounded-md border border-slate-200 bg-white py-1.5 pl-1.5 pr-3 text-left shadow-sm transition hover:border-slate-300 hover:bg-slate-50"
                onClick={() => setDropdownOpen(!dropdownOpen)}
                type="button"
                aria-haspopup="menu"
                aria-expanded={dropdownOpen}
            >
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-emerald-50 text-sm font-semibold text-emerald-700">
                    {initial}
                </span>
                <span className="hidden max-w-[150px] truncate text-sm font-semibold text-slate-700 lg:block">
                    {username || "Username"}
                </span>
                <span className="hidden lg:block"><ArrowDown fill="general-70" /></span>
            </button>
        {dropdownOpen && 
        <div
            className="absolute right-0 top-12 z-40 flex w-64 flex-col rounded-lg border border-slate-200 bg-white shadow-xl"
        >
            <ul
                className="flex list-none flex-col gap-1 p-2"
            >
                <li>
                    <Link to="/my/profile"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-slate-700 duration-200 ease-in-out hover:bg-slate-100 hover:text-slate-950"
                    >
                        <PersonIcon fontSize="small"/>
                        My Profile
                    </Link>
                </li>
                <li>
                    <Link to="/my/subscription"
                        onClick={() => setDropdownOpen(false)}
                        className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-slate-700 duration-200 ease-in-out hover:bg-slate-100 hover:text-slate-950"
                    >
                        <CreditCardIcon fontSize="small"/>
                        Subscription
                    </Link>
                </li>
                <li>
                    <Link 
                        onClick={onLogout}
                        to="#"
                        className="flex items-center gap-3 rounded-md px-3 py-2.5 text-sm font-medium text-slate-700 duration-200 ease-in-out hover:bg-slate-100 hover:text-slate-950"
                    >
                        <LogoutIcon fontSize="small"/>
                        Log Out
                    </Link>
                </li>
            </ul>
        </div>
        }
       </div>
    )
}
